import Dashboard from '@/views/Dashboard.vue';

const pubRoutes = [
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    meta: { publicRoute: true, layout: 'Basic', maxBreakpoint: 'sm' },
  },
  {
    name: 'passwordReset',
    path: '/password/reset',
    component: () => import('@/views/Login/PasswordReset.vue'),
    meta: { publicRoute: true, backRoute: 'login', layout: 'Basic' },
  },
  {
    name: 'passwordChange',
    path: '/password/change',
    component: () => import('@/views/Login/PasswordChange.vue'),
    meta: { publicRoute: true, layout: 'Basic' },
  },
];

const OCRoutes = [
  {
    name: 'dashboard',
    path: 'dashboard',
    component: Dashboard,
  },
];

export default { pubRoutes, OCRoutes };
